import {
  LIST_PROFESSION_SUMMARY_REQUEST,
  LIST_PROFESSION_SUMMARY_SUCCESS,
  LIST_PROFESSION_SUMMARY_FAIL
} from '../../constants/professions'

const initialState = {
  loading: false,
  professionsSummary: [],
  error: null,
  pageable: {}
}

const listProfessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PROFESSION_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_PROFESSION_SUMMARY_SUCCESS:
      return { ...state, loading: false, professionsSummary: action.payload }
    case LIST_PROFESSION_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default listProfessionReducer
